module.exports = __webpack_public_path__ + "img/icono-20-1.128dd4b0.png";